import { JsonObject, JsonProperty } from 'ta-json';
import {
  GetDocumentationBySubjectType_documentationBySubjectType_fields,
} from '@src/app/generated/GetDocumentationBySubjectType';

@JsonObject()
export class PropertyField {
  @JsonProperty() fieldName: string;
  @JsonProperty() fieldType: string;
  @JsonProperty() required: boolean;

  constructor(
    fieldName: string,
    fieldType: string,
    required: boolean = true,
  ) {
    this.fieldName = fieldName;
    this.fieldType = fieldType;
    this.required = required;
  }

  static fromGql(gql: GetDocumentationBySubjectType_documentationBySubjectType_fields): PropertyField {
    return new PropertyField(
      gql.fieldName,
      gql.fieldType,
      gql.required
    );
  }
}
